<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="8">
                <el-card shadow="never">
                    <el-form ref="form" :model="form" label-position="top" label-width="80px">
                        <el-form-item label="标题">
                            <el-input v-model="form.title" placeholder="请输入标题"></el-input>
                        </el-form-item>
                        <el-form-item label="副标题">
                            <el-input v-model="form.summary" placeholder="请输入副标题"></el-input>
                        </el-form-item>
                        <el-form-item label="作者名称">
                            <el-input type="text" v-model="form.author" style="width:300px"></el-input>
                        </el-form-item>
                        <el-form-item label="作者头像">
                            <imgBox :imgUrl="form.head_portrait" inline @click="handleImgChange"></imgBox>
                            <imgPicker :dialog-visible="imgDialog" :sc-status="isGetImage" @chooseImg="pickImg"
                                       @closeImgDialog="closeImgDialog"></imgPicker>
                        </el-form-item>
                        <el-form-item label="文章类目选择">
                            <el-select v-model="form.category_id" placeholder="请选择">
                                <el-option
                                        v-for="item in categoryList"
                                        :key="item.category_id"
                                        :label="item.category_name"
                                        :value="item.category_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="地区选择" v-if="renderable">
                            <region-select @change="changeRegion" :defaultAddress="defaultAddress"></region-select>
                            <span style="cursor: pointer" @click="handleSynchronous()">点击地区同步到标题</span>
                        </el-form-item>
                        <el-form-item label="封面图">

                            <div>
                              <div class="pics-box">
                                <ul class="goodspic-wrap">
                                  <draggable v-model="form.pics" :options="dragIssuesOptions" class="components-view">
                                    <li v-for="(item, index) in form.pics" :key='index' class="goodspic" @mouseenter="picsEnter(index)" @mouseleave="picsLeave">
                                      <img :src="wximageurl + item" />
                                      <div class="goodspic-mask" :class="(picsCurrent == index) ? 'on' : ''">
                                        <div class="iconfont icon-trash-alt" @click="removePicsImg(index)"></div>
                                        <div class="iconfont icon-arrows-alt"></div>
                                      </div>
                                    </li>
                                  </draggable>
                                </ul>
                                <div v-if="form.pics.length < 9" class="upload-box" @click="handlePicsChange">
                                  <i class="iconfont icon-camera"></i>
                                </div>
                              </div>
                              <div class="frm-tips">
                                <p>1. 最多可上传9个图片，文件格式为bmp、png、jpeg、jpg或gif，大小不超过2M（建议尺寸：500px * 500px）</p>
                                <p>2. 拖动图片进行可排序</p>
                              </div>
                            </div>
                            <imgPicker :dialog-visible="picsDialog" :sc-status="isGetPics" :is-most="multiple" @chooseImg="pickPics" @closeImgDialog="closePicsDialog"></imgPicker>

                            <!-- <div>封面小图片 <span class="form-text-tip">建议尺寸：200像素 * 200像素</span></div>
                            <el-button @click="addThumbPreview">从图片库选择</el-button>
                            <imgBox v-if="form.image_url" :imgUrl="wximageurl + form.image_url"></imgBox> -->
                            <el-form-item label="封面图样式">
                            <el-select v-model="form.img_style" placeholder="请选择">
                                <el-option
                                        v-for="item in imgStyle"
                                        :key="item.value"
                                        :label="item.name"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                            </el-form-item>
                        </el-form-item>
                        <!-- <el-form-item label="商城商品选择">
                          <el-select style="width: 40%;" v-model="relItemsShops" filterable placeholder="请输入商品编号" remote :remote-method="getItemShopsList" @change="handleItemShopsChange" multiple>
                              <el-option
                                      v-for="item in relItemsShopsList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id"
                              >
                              </el-option>
                          </el-select>
                          <div v-show="false">
                              <el-col ><el-input v-model="relItemsShopsVal" placeholder=""></el-input></el-col>
                          </div>
                      </el-form-item> -->
                    </el-form>
                </el-card>
            </el-col>
            <el-col :span="16">
                <el-card shadow="never">
                    <div :style="'height:' + (wheight-195) +'px;'">
                        <richText @change="handleRichTextChange"
                                  :control="['film','goods','slider','heading','writing']"
                                  :data="form.content"></richText>
                    </div>
                </el-card>
            </el-col>
            <imgPicker :dialog-visible="thumbDialog" :sc-status="isGetThumb" @chooseImg="pickThumb"
                       @closeImgDialog="closeThumbDialog"></imgPicker>
        </el-row>

        <div class="content-center">
            <el-button type="primary" @click="onSubmit">保存</el-button>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {createArticle, getArticleCategoryList, getArticleInfo, updateArticle} from '@/api/article'
  import { getItemsDetail, createItems, updateItems, getCategory, getGoodsAttr, getCategoryInfo } from '@/api/goods'
  import { getShippingTemplatesList } from '@/api/shipping'
  import imgPicker from '@/components/imageselect'
  import imgBox from '@/components/element/imgBox'
  import richText from '@/components/function/richTextEditor'
  import regionSelect from '@/components/regionSelect'
  import draggable from 'vuedraggable'
  import {
        saveLive as saveForm,
        getLiveDetail as getDetail,
        getAnchorList,
        getShopItemsDetail,
        getLiveConf,
        getCateList,
    } from '../../../api/live'
  export default {
    inject: ['refresh'],
    components: {
      imgPicker,
      imgBox,
      richText,
      draggable,
      regionSelect
    },
    data() {
      return {
        imgDialog: false,
        thumbDialog: false,
        isGetImage: false,
        isGetThumb: false,
        synchronous: false,
        article_id: '',
        categoryList: [],
        relItemsShopsList:[],
        relItemsShopsVal:"",
        relItemsShops:"",
        form: {
          title: '',
          summary: '',
          article_type: 'bring',
          content: [],
          image_url: '',
          author: '',
          head_portrait: '',
          article: '',
          pics: [],
          item_bn:'',
          img_style:0,
          category_id: '',
          shopsItem:[],
        },
        dragIssuesOptions: {
          animation: 300,
          forceFallback: true,
          scroll: true,
          handle: '.icon-arrows-alt',
          draggable: '.goodspic'
        },
        imgStyle:[
          {name: "请选择", value: 0},
          {name: "居左", value: 1},
          {name: "居右", value: 2},
          {name: "居上", value: 3},
          {name: "居下", value: 4},
        ],
        dialogVisible: false,
        dialogImageUrl: '',
        thumbDialog: false,
        isGetThumb: false,
        isGetPics: false,
        picsDialog: false,
        picsCurrent: -1,
        picsOldLen: 0,
        currentSku: -1,
        currentPage: 1,
        multiple: false,
        mode: 'richText',
        renderable: true,
        multiple: false,
        templatesList: [],
        brandList:[],
        address_title: '',
        defaultAddress: [],
        ids:[]
        // defaultAddress: ['150000', '150400', '150404'] // 默认要显示的地址id
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      handleSynchronous() {
        if (this.address_title) {
          let title = this.form.title.replace(/^\[(.+?)\]/g, '')
          this.form.title = '[' + this.address_title + ']' + title
        }
      },
      addThumbPreview() {
        this.thumbDialog = true
        this.isGetThumb = true
      },
      pickThumb(data) {
        if (data && data.url !== '') {
          this.thumbDialog = false
          this.form.image_url = data.url
        }
      },
      closeThumbDialog() {
        this.thumbDialog = false
      },
      handleRichTextChange(data) {
        this.form.content = data
      },
      picsEnter (index) {
        this.picsCurrent  = index
      },
      picsLeave () {
        this.picsCurrent  = -1
      },
      removePicsImg: function (index) {
        this.form.pics.splice(index, 1)
        this.picsOldLen = this.form.pics.length
      },
      //上传商品图（9张）
      handlePicsChange: function () {
        this.picsDialog = true
        this.isGetPics = true
        this.multiple = true
      },
      closePicsDialog () {
        this.picsDialog = false
      },
      pickPics (data) {
        if (this.currentSku === -1) {
          if (this.picsOldLen + data.length >= 10) {
            this.$message.error('最多上传9张图片!')
            return false
          }else {
            if (data.length != 0) {
              data.forEach(data => {
                if (data && data.url !== '') {
                  this.form.pics.push(data.url)
                  this.picsOldLen = this.form.pics.length
                }
              })
            }
          }
        } else {
          if (this.specImages[this.currentSku].item_image_url.length + data.length > 5) {
            this.$message.error('最多添加5张图片!')
            return false
          }
          if (data.length > 0) {
            data.forEach(data => {
              if (data && data.url !== '') {
                this.specImages[this.currentSku].item_image_url.push(data.url)
              }
            })
          }
          this.currentSku = -1
        }
        this.picsDialog = false
      },
      init () {
        getGoodsAttr({page: 1, pageSize: 500, attribute_type: 'brand'}).then(res => {
          for (let item of res.data.data.list) {
            this.brandList.push({attribute_name: item.attribute_name, attribute_id: item.attribute_id})
          }
        })

        getShippingTemplatesList(this.templatesListParams).then(response => {
          if (response.data.data.list.length > 0) {
            for(var i in response.data.data.list) {
              this.templatesList.push({
                'template_id': response.data.data.list[i].template_id,
                'name': response.data.data.list[i].name
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: '请先添加运费模板'
            })
            this.$router.push({path: this.matchInternalRoute('shippingtemplates')})
          }
        })

        // getCategory({is_show:false}).then(response => {
        //   this.categoryList = response.data.data
        // })
      },
      fetchMainCate() {
        getCategory({is_main_category: true}).then(res => {
          let list = []
          res.data.data.forEach(item => {
            let obj = {
              label: item.category_name,
              value: item.category_id,
              children: []
            }
            if (item.children.length > 0) {
              item.children.forEach(child => {
                let childObj = {
                  label: child.category_name,
                  value: child.category_id,
                  children: []
                }
                obj.children.push(childObj)
                if (child.children.length > 0) {
                  child.children.forEach(sub => {
                    let subObj = {
                      label: sub.category_name,
                      value: sub.category_id
                    }
                    childObj.children.push(subObj)
                  })
                }
              })
            }
            list.push(obj)
          })
          this.mainCategory = list
          this.mainCateLoader = false
        })
      },
      onSubmit() {
        let param = {}
        if (this.article_id) {
          updateArticle(this.article_id, this.form).then(response => {
            const that = this
            this.$message({
              message: '修改文章成功',
              type: 'success',
              duration: 2 * 1000,
              // onClose() {
              //   that.refresh()
              //   that.$router.go(-1)
              // }
            })
          })
        } else {

          createArticle(this.form).then(res => {
            const that = this
            this.$message({
              message: '添加文章成功',
              type: 'success',
              duration: 2 * 1000,
              // onClose() {
              //   that.refresh()
              //   that.$router.go(-1)
              // }
            })
          })
        }
      },
      handleImgChange() {
        this.imgDialog = true
        this.isGetImage = true
      },
      pickImg(data) {
        this.form.head_portrait = data.url
        this.imgDialog = false
      },
      closeImgDialog() {
        this.imgDialog = false
      },
      changeRegion(values) {
        this.address_title = [values.city + values.area]
        this.form = Object.assign({}, this.form, values)
      },
      getArticleCategory() {
        this.loading = true
        let params={
          category_type: 'bring'
        }
        getArticleCategoryList(params).then(response => {
          this.categoryList = response.data.data
          this.loading = false
        })
      },

      getItemShopsList(val){
          getShopItemsDetail({page: 1, pageSize: 50,id:val}).then(res => {
              this.relItemsShopsList = [];
              for (let item of res.data.data.list) {
                  this.relItemsShopsList.push({name: item.item_name, id: item.item_id})
              }
          })
      },
      handleItemShopsChange:function (val){
          this.form.shopsItem = val
      },
    },
    mounted() {
      var that = this
      this.anchor_id = this.$route.params.id
      getDetail(this.$route.params).then(res => {
          if(res.data.data){
              if(this.anchor_id){
                  this.is_new = false;
              }
              // that.sourceVideoTypeOption.forEach((v,k)=>{
              //     if(v.value == res.data.data.source_video_type){
              //         res.data.data.source_video_type_text = v.name
              //     }
              // });
              res.data.data.is_record = res.data.data.is_record ?  '1' : '0';
              that.form = res.data.data
              var jsonRole = res.data.data.video_rules!=''?JSON.parse(res.data.data.video_rules):'';
              if(jsonRole!='')
              {
                  that.attr_values = jsonRole.integral?jsonRole.integral:[];
                  that.money_values = jsonRole.money?jsonRole.money:[];
                  var coupon = jsonRole.coupon?jsonRole.coupon[0]:'';
                  if(coupon!='')
                  {
                      that.coupons.checked = coupon.coupon_info
                      that.coupon_type = coupon.type
                      that.coupon_time = coupon.time
                  }
              }
              that.form.start_at = res.data.data.start_at_text
              that.relItems = res.data.data.storeItemList
              that.relItemsShopsList = res.data.data.shopsItemList
              that.relItemsShops = res.data.data.shopsItem
          }
      });
      if (this.$route.query.id) {
        this.renderable = false
        this.article_id = this.$route.query.id
        getArticleInfo(this.$route.query.id).then(res => {
          if (res.data.data) {
            this.ids = res.data.data.item_bn?res.data.data.item_bn.split(","):[]
            this.form.title = res.data.data.title
            this.form.summary = res.data.data.summary
            this.form.content = res.data.data.content
            this.form.image_url = res.data.data.image_url
            this.form.author = res.data.data.author
            this.form.category_id = res.data.data.category_id
            this.form.head_portrait = res.data.data.head_portrait
            this.defaultAddress = res.data.data.regions_id
            this.form.img_style = res.data.data.img_style
            this.form.pics = res.data.data.pics?res.data.data.pics:[]
            
            this.$nextTick(_ => {
              this.renderable = true
            })

          }
          getShopItemsDetail({page: 1, pageSize: 50,id:this.ids}).then(msg => {  
              this.relItemsShopsList = [];
              for (let item of msg.data.data.list) {
                  this.relItemsShops.push({name: item.item_name, id: item.item_id})
              }
              console.log(this.relItemsShops)
          })
        })

      }
      this.getArticleCategory()
      

      const _self = this
      async function onload () {
        if (_self.$route.query.is_new) {
          _self.is_new = _self.$route.query.is_new
        }
        await _self.init()
        if (_self.$route.params.itemId) {
          _self.isEditor = true
          _self.mainCateLoader = true
          // 初始化门店数据
          await getItemsDetail(_self.$route.params.itemId).then(response => {
            let itemsDetailData = response.data.data
            if (itemsDetailData.regions_id) {
              _self.select_regions_value = itemsDetailData.regions_id
            }
            _self.form.pics = itemsDetailData.pics
            // 处理图片列表
            var picList = []
            for (var item in itemsDetailData.pics) {
              var newpic = {}
              newpic.url = _self.wximageurl + itemsDetailData.pics[item]
              picList.push(newpic)
            }
            _self.picsList = picList
            let obj = _self.form
            _self.form = ({obj} = {
              item_id: _self.is_new ? '' : itemsDetailData.item_id,
              item_source: itemsDetailData.item_source,
              item_type: itemsDetailData.item_type,
              special_type: itemsDetailData.special_type,
              item_category: itemsDetailData.item_category.length > 0? itemsDetailData.item_category : [],
              item_name: itemsDetailData.item_name,
              sort: itemsDetailData.sort,
              item_bn: _self.is_new ? '' : itemsDetailData.item_bn,
              brief: itemsDetailData.brief,
              weight: itemsDetailData.weight,
              volume: itemsDetailData.volume,
              price: itemsDetailData.price/100,
              market_price: itemsDetailData.market_price/100,
              cost_price: itemsDetailData.cost_price/100,
              barcode: itemsDetailData.barcode,
              item_unit: itemsDetailData.item_unit,
              rebate: itemsDetailData.rebate/100,
              store: itemsDetailData.store,
              brand_id: itemsDetailData.brand_id,
              templates_id: itemsDetailData.templates_id ? itemsDetailData.templates_id.toString() : '',
              approve_status: itemsDetailData.approve_status,
              pics: itemsDetailData.pics,
              producer: itemsDetailData.producer,
              Reg_No_: itemsDetailData.Reg_No_,
              unit_zhuan_huan_value: itemsDetailData.unit_zhuan_huan_value,
              spec: itemsDetailData.spec,
              videos: itemsDetailData.videos,
              videos_url: itemsDetailData.videos_url,
              nospec: itemsDetailData.nospec,
              is_show_specimg: itemsDetailData.is_show_specimg,
              item_params: itemsDetailData.item_params,
              item_main_cat_id: itemsDetailData.item_main_cat_id,
              is_settle_in:itemsDetailData.is_settle_in,
              is_NP_store:itemsDetailData.is_NP_store,
              is_settle_in_service:itemsDetailData.is_settle_in_service,
              si_charging_method:itemsDetailData.si_charging_method,
              si_rate:itemsDetailData.si_rate,
              si_fixed_costs:itemsDetailData.si_fixed_costs
            })
            _self.picsOldLen = _self.form.pics.length
            if (!itemsDetailData.item_main_cat_id) {
              _self.fetchMainCate()
            } else {
              let category = itemsDetailData.item_category_main
              _self.categoryNames = [category[0].category_name, category[0].children[0].category_name, category[0].children[0].children[0].category_name]
              _self.generateParams(itemsDetailData.item_params_list)
            }
            if (!_self.form.nospec) {
              _self.generateSpec(itemsDetailData.item_spec_list)
              _self.specImages = itemsDetailData.spec_images
              itemsDetailData.spec_items.forEach(item => {
                item.item_spec.forEach(child => {
                  let checkedIndex = _self.skus.findIndex(n => child.spec_id === n.sku_id)
                  let isin = _self.skus[checkedIndex].checked_sku.findIndex(k => child.spec_value_id === k)
                  if (isin === -1) {
                    _self.skus[checkedIndex].checked_sku.push(child.spec_value_id)
                  }
                })
              })

              itemsDetailData.spec_items.forEach(item => {
                let sku = Object.assign({}, item)
                sku.market_price = item.market_price/100
                sku.cost_price = item.cost_price/100
                sku.price = item.price/100
                sku.item_bn = _self.is_new ? '' : item.item_bn
                let itemId = []
                let specs = []
                item.item_spec.forEach(sub => {
                  specs.push({
                    spec_id: sub.spec_id,
                    spec_value_id: sub.spec_value_id,
                    spec_value_name: sub.spec_value_name,
                    spec_custom_value_name: sub.spec_custom_value_name || ''
                  })
                  itemId.push(sub.spec_value_id)
                })
                sku.item_spec = specs
                itemId = itemId.join('_')
                Object.assign(sku, {sku_id: itemId})
                store.dispatch('setSku', sku)
              })
              _self.updateSku()
            }
            if (typeof itemsDetailData.intro === 'object') {
              _self.mode = 'component'
              _self.content = itemsDetailData.intro
            } else {
              _self.form.intro = itemsDetailData.intro
            }
          })
          // .catch(error => {
          //   _self.$router.go(-1)
          // })
          _self.loader = false
          _self.itemVideo = {media_id:_self.form.videos, url:_self.form.videos_url}
        } else {
          _self.fetchMainCate()
          _self.loader = false
        }
      }
      onload()
    }
  }
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// editor.vue?69705d64